import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

// tslint:disable-next-line:no-any
export class UsersWithProfilePicsExtractChannel extends MicroviewCommunicationChannel<string[], any> {
  public name: string = 'UsersWithProfilePicsExtractChannel';
  public namespace: string = 'VPC.UsersWithProfilePicsExtract';
}
